<form [formGroup]="form"
  (ngSubmit)="save()"
  class="side-form">

  <h3>{{mode === EditMode.Edit ? 'Update' : 'Create'}} role</h3>

  <mat-form-field appearance="fill">
    <mat-label>Name</mat-label>
    <input matInput
      formControlName="name">
    @if (form.get('name').hasError('required')) {
      <mat-error>
        Name is <strong>required</strong>
      </mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>Scopes</mat-label>
    <mat-select formControlName="scopes"
      multiple>
      @for (scope of scopes; track scope) {
        <mat-option
          [value]="scope">
          {{scope}}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>

  <div class="side-form-actions">
    <button mat-raised-button
      type="submit"
      color="primary"
      [disabled]="form.invalid">
      {{mode === EditMode.Edit ? 'Update' : 'Create'}}
    </button>
  </div>

  <app-form-error></app-form-error>
</form>
